<template>
    <div id="slide_box" class="slide1">
        <div id="slide_content" :style="{background: siteCodeInfo[0].BACK_COLOR}">
            <div class="slide_block" id="slide1" :class="getShowClass()">
                <div class="slide_animate_block">
                    <form @submit.prevent="submitConfirmDisp">
                        <div class="bg" :style="{background: siteCodeInfo[0].BACK_COLOR}">
                            <div class="wrap01">
                                <h2 class="stitle"><span>お申込み内容・料金を</span><br><span>ご確認ください。</span></h2>
                                <p class="commonError" v-if="$errorFlg">{{$msg.ERROR.MSG_9995}}<br>{{$msg.ERROR.MSG_9996}}</p>
                                <section class="confirm_section">
                                    <div class="title_box">
                                        <h3>ご希望回収日時</h3>
                                    </div>
                                    <div id="time_box">
                                        <p id="day_txt"><span id="month">{{ specificDate.split('/')[1] }}</span>月<span id="day">{{ specificDate.split('/')[2] }}</span>日<span id="youbi">{{ specificDay }}</span></p>
                                        <p id="time">{{ specificTime.CODE_NM }}</p>
                                    </div>
                                    <div id="caution_box" v-if="mediumSmallQuantity">
                                        <p v-if="largeQuantity"><strong id="caution_msg4">大型家電以外の</strong></p>
                                        <p>回収品は<strong id="caution_msg1">{{mediumSmallQuantity}}箱に梱包</strong>して<br>お送りください。</p>
                                    </div>
                                </section>

                                <section class="confirm_section" :class="{m_t_3: largeQuantity}">
                                    <div class="message_box" v-if="largeQuantity">
                                        <p>※大型家電については、<br>回収前のお電話をもって回収日時の確定となります。</p>
                                    </div>
                                    <div class="title_box">
                                        <h3>回収情報</h3>
                                    </div>
                                    <div id="customer">
                                        <p class="title"><span>【お客様情報】</span></p>
                                        <dl id="address_box">
                                            <dt>住所</dt>
                                            <dd id="address">〒{{ postCode }}<br>{{ pickupPrefAddress1 + address + buildingName }}</dd>
                                        </dl>
                                        <dl id="name_box">
                                            <dt>お名前</dt>
                                            <dd id="name">{{ sei_kj + ' ' + mei_kj }}<span id="kana">{{ '（' + sei_kn + ' ' + mei_kn + '）' }}</span></dd>
                                        </dl>
                                        <dl id="email_box">
                                            <dt>メールアドレス</dt>
                                            <dd id="email">{{ email }}</dd>
                                        </dl>
                                        <dl id="tel_box">
                                            <dt>電話番号</dt>
                                            <dd id="tel">{{ pickupTell }}</dd>
                                        </dl>
                                        <dl id="tel_home_box">
                                            <dt>ご自宅電話番号</dt>
                                            <dd id="tel_home">{{ pickupTell2 }}</dd>
                                        </dl>
                                    </div>
                                </section>

                                <section v-if="siteCodeInfo[0].CHECK_COLLECTED_ITEMS_AND_CHARGES_DISPLAY_FLG == '1'" class="confirm_section">
                                    <div class="title_box">
                                        <h3>回収品目/{{ largeQuantity ? "見積り料金" : "お支払合計" }}</h3>
                                    </div>
                                    <div id="item_big_box">
                                        <div class="item_box" v-for="(large_item, index) in selctedLargeItems" :key="index + 'L'">
                                            <p class="title_txt"><span class="title">{{ large_item.ITEM_CD_NM }}/{{ large_item.MAKER_NM }}</span></p>
                                            <table>
                                                <tr>
                                                    <td class="stitle">収集運搬料金</td>
                                                    <td class="no">1台</td>
                                                    <td class="price">￥{{ large_item.TRANSPORTATION_FEE.toLocaleString() }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="stitle">リサイクル料金<sup>※</sup></td>
                                                    <td class="no">1台</td>
                                                    <td class="price">{{ large_item.RECYCLE_FEE_LOW == large_item.RECYCLE_FEE_HIGH ? ('￥' + large_item.RECYCLE_FEE_LOW.toLocaleString()) : ('￥' + large_item.RECYCLE_FEE_LOW.toLocaleString() + '～￥' + large_item.RECYCLE_FEE_HIGH.toLocaleString()) }}</td>
                                                </tr>
                                                <tr v-if="large_item.REMOVAL_FEE">
                                                    <td class="stitle">取り外し料金<sup>※</sup></td>
                                                    <td class="no">1台</td>
                                                    <td class="price">￥{{ large_item.REMOVAL_FEE.toLocaleString() }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="item_box bottom_line" v-if="largeQuantity">
                                            <table>
                                                <tr>
                                                    <td class="title">小計（SGムービング回収分）</td>
                                                    <td class="price" v-if="largeTotalFeeExc[0] == largeTotalFeeExc[1]">￥{{ ( largeTotalFeeExc[0]-feeData.commission_sgm).toLocaleString() }}</td>
                                                    <td class="price" v-else>￥{{ (largeTotalFeeExc[0]-feeData.commission_sgm).toLocaleString() }}～￥{{ (largeTotalFeeExc[1]- feeData.commission_sgm).toLocaleString() }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="item_box bottom_line" v-if="largeQuantity">
                                            <table>
                                                <tr>
                                                    <td class="title">代引き手数料（SGムービング回収分）</td>
                                                    <td class="price">￥{{Number(feeData.commission_sgm).toLocaleString() }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="item_box bottom_line" style="margin-bottom: 50px;" v-if="largeQuantity">
                                            <table>
                                                <tr>
                                                    <td class="title title_short">消費税（SGムービング回収分）</td>
                                                    <td class="price" v-if="largeTotalFeeInc[0] == largeTotalFeeInc[1]">￥{{ (largeTotalFeeInc[0] - largeTotalFeeExc[0]).toLocaleString() }}</td>
                                                    <td class="price price_long" v-else>￥{{ (largeTotalFeeInc[0]- largeTotalFeeExc[0]).toLocaleString() }}～￥{{ (largeTotalFeeInc[1]- largeTotalFeeExc[1]).toLocaleString() }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div v-if="siteCodeInfo[0].PRICING_METHOD == 2">
                                            <div class="item_box" v-for="(medium_item, index) in selctedMediumItems" :key="index + 'M'">
                                                <table>
                                                    <tr>
                                                        <td class="title" colspan="3">{{ medium_item.name }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="stitle">{{ getMainFeeKbnName(feeData.medium_items, medium_item.code) }}</td>
                                                        <td class="no">{{ medium_item.unit }}台</td>
                                                        <td class="price">￥{{ (medium_item.fee * medium_item.unit).toLocaleString() }}</td>
                                                    </tr>
                                                    <tr v-for="(option, index) in medium_item.options" :key="index + 'O'">
                                                        <td class="stitle">{{ getSelectedFeeCatName(medium_item, option) }}</td>
                                                        <td class="no">{{ medium_item.unit }}台</td>
                                                        <td class="price">￥{{ (option.fee * medium_item.unit).toLocaleString() }}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="item_box" v-if="addMediumItem.unit > 0">
                                                <table>
                                                    <tr>
                                                        <td class="title" colspan="3">{{ addMediumItem.name }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="stitle">{{ getMainFeeKbnName(feeData.medium_items, addMediumItem.code) }}</td>
                                                        <td class="no">{{ addMediumItem.unit }}台</td>
                                                        <td class="price">￥{{ (addMediumItem.fee * addMediumItem.unit).toLocaleString() }}</td>
                                                    </tr>
                                                    <tr v-for="(option, index) in addMediumItem.options" :key="index + 'O'">
                                                        <td class="stitle">{{ getSelectedFeeCatName(addMediumItem, option) }}</td>
                                                        <td class="no">{{ medium_item.unit }}台</td>
                                                        <td class="price">￥{{ (option.fee * addMediumItem.unit).toLocaleString() }}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="item_box" v-for="(small_item, index) in feeData.small_items" :key="index + 'S'">
                                                <table>
                                                    <tr>
                                                        <td class="title" colspan="3">その他小型家電</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="stitle">{{ getMainFeeKbnName(feeData.small_items, small_item.ITEM) }}</td>
                                                        <td class="no">{{ smallItems.quantity }}箱</td>
                                                        <td class="price">￥{{ (small_item.FEE * smallItems.quantity).toLocaleString() }}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div v-else class="item_box">
                                            <table>
                                                <tr>
                                                    <td class="title">回収箱数</td>
                                                    <td class="no">{{ mediumSmallQuantity }}箱</td>
                                                    <td class="price">￥{{ total_m_s_exc.toLocaleString() }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="item_box bottom_line" v-if="mediumSmallQuantity">
                                            <table>
                                                <tr>
                                                    <td class="title">小計（佐川急便回収分）</td>
                                                    <td class="price">￥{{ (MSTotalFeeExc[0]- feeData.commission_sgw).toLocaleString()}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="item_box bottom_line" v-if="mediumSmallQuantity">
                                            <table>
                                                <tr>
                                                    <td class="title">代引き手数料（佐川急便回収分）</td>
                                                    <td class="price">￥{{ Number(feeData.commission_sgw).toLocaleString()}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="item_box bottom_line" style="margin-bottom: 50px;" v-if="mediumSmallQuantity">
                                            <table>
                                                <tr>
                                                    <td class="title">消費税（佐川急便回収分）</td>
                                                    <td class="price">￥{{ (MSTotalFeeInc[0]-MSTotalFeeExc[0] ).toLocaleString()}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="price_box">
                                            <p class="price_title">{{ largeQuantity ? "見積り料金（税込）" : "お支払合計（税込）" }}</p>
                                            <p class="price_txt" v-if="largeTotalFeeInc[0] == largeTotalFeeInc[1]"><span>￥{{ (largeTotalFeeInc[0] + MSTotalFeeInc[0]).toLocaleString() }}</span>円</p>
                                            <p class="price_txt" v-else><span>￥{{ (largeTotalFeeInc[0] + MSTotalFeeInc[0]).toLocaleString() }}～￥{{ (largeTotalFeeInc[1] + MSTotalFeeInc[1]).toLocaleString() }}</span>円</p>
                                        </div>
                                        <ul class="caution_txt">
                                            <li v-html="siteCodeInfo[0].GUIDE_WORD1_SP"></li>
                                            <li v-html="siteCodeInfo[0].GUIDE_WORD2_SP"></li>
                                        </ul>
                                    </div>
                                </section>

                                <div v-if="siteCodeInfo[0].REQUIRE_CONTRACT_FLG == '1'">
                                    <div id="contract_area" class="contract_area"></div>
                                    <div @click="contractDownload()" class="statement contract_download">契約書のダウンロードはこちら</div>
                                </div>

                                <div v-if="siteCodeInfo[0].MAIL_OSR_SELECTIVE_DISPLAY_FLG == mailOsrSelectiveDisplay" class="info_check_box">
                                    <p>
                                        <label class="form_Checkbox">
                                            <input class="ckboxInput" type="checkbox" name="info" v-model="mail_osr">
                                            <span class="dummyInput"></span>
                                            <span class="labelText">リサイクルやリユースのお得な情報を受け取る</span>
                                        </label>
                                    </p>
                                </div>

                                <p class="next_page"><button type="submit" class="form-Button-01" :style="{backgroundColor : siteCodeInfo[0].NEXT_PAGE_BTN_COLOR}">申込む</button></p>
                                <p class="comment_txt_01">
                                    「申込む」ボタンを押していただくと、本サービスの<br>
                                    <a class="statement" :href="siteCodeInfo[0].POLICY_URL" target="_blank">個人情報保護方針</a>・
                                    <a class="statement" :href="siteCodeInfo[0].PRIVACY_URL" target="_blank">プライバシーポリシー</a>・
                                    <a class="statement" :href="siteCodeInfo[0].LICENSE_URL" target="_blank">ご利用規約</a>に<br>
                                    同意されたものとみなされます。
                                </p>
                                <div class="link_box">
                                    <p class="back_page"><span class="form-Button-back" @click="pageBack">戻る</span></p>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConfirmDisp from '../../js/ConfirmDisp'

export default {
    props: {
        siteCodeInfo: Array,
        enqueteMaster: Array
    },
    data() {
        return {
            specificDate: '',
            specificDay: '',
            specificTime: '',
            postCode: '',
            pickupPrefAddress1: '',
            address: '',
            buildingName: '',
            pickupTell: '',
            pickupTell2: '',
            email: '',
            largeItems: [],
            mediumItems: [],
            addMediumItem: [],
            smallItems: [],
            sei_kj: '',
            mei_kj: '',
            sei_kn: '',
            mei_kn: '',
            birthday: '',
            gender: '',
            feeData: '',
            itemsDataTax: '',
            // 大型の合計金額(税抜)
            largeTotalFeeExc: [0, 0],
            // 大型の合計金額(税込)
            largeTotalFeeInc: [0, 0],
            // 中型・小型の合計金額(税抜)
            MSTotalFeeExc: [0, 0],
            // 中型・小型の合計金額(税込)
            MSTotalFeeInc: [0, 0],
            mail_osr: true,
            // 中型・小型の合計金額(税込)(手数料抜)
            total_m_s_inc: 0,
            //サンクス画面用データ部品
            // 中型・小型の合計金額(税抜)(手数料抜)
            total_m_s_exc: 0,
            mediumSmallQuantity: 0,
            largeQuantity: 0,
            mailOsrSelectiveDisplay: ConfirmDisp.common.constant.MAIL_OSR_SELECTIVE_DISPLAY
        }
    },
    computed:{
        selctedMediumItems() {
            return this.mediumItems.filter(item => item.unit > 0).sort((a, b) => Number(a.code) > Number(b.code) ? 1 : -1);
        },
        selctedLargeItems() {
          let large_items = this.feeData == "" ? [] : this.feeData.large_items;
          return large_items.sort((a, b) => Number(a.ITEM) > Number(b.ITEM) ? 1 : -1);
        }
    },
    mounted() {
        ConfirmDisp.inputRetention(this)
        ConfirmDisp.getFee(this)
    },
    methods: {
        submitConfirmDisp() {
            ConfirmDisp.submitConfirmDisp(this, ConfirmDisp.common.constant.COMPLETE_PAGE_PATH)
        },
        pageBack() {
            ConfirmDisp.common.pageBack(this, ConfirmDisp.common.constant.CUSTOMER_INFORMATION_PATH)
        },
        getSelectedFeeCatName(item, option) {
            return ConfirmDisp.getSelectedFeeCatName(item, option)
        },
        getMainFeeKbnName(item, code) {
            return ConfirmDisp.getMainFeeKbnName(item, code)
        },
        contractDownload() {
            ConfirmDisp.contractDownload(this)
        }
    }
}

</script>
